/**
 * Biometric login helpers — DISABLED (iter96h).
 *
 * WHY DISABLED: @capgo/capacitor-native-biometric v8.6.0 launches its own
 * native `ee.forgr.biometric.AuthActivity`, which ALWAYS calls
 * `BiometricPrompt.authenticate(promptInfo, cryptoObject)` with a
 * crypto object bound to BIOMETRIC_STRONG — even for a plain
 * `verifyIdentity`. On devices whose enrolled biometric is Class 2 (Weak),
 * e.g. Samsung face unlock, Android throws
 * "Crypto-based authentication is not supported for Class 2 (Weak)
 * biometrics" and KILLS the app process (confirmed via device logcat on
 * multiple builds). This is a plugin-level defect that CANNOT be worked
 * around from JavaScript. Until we swap to a plugin that supports weak
 * biometrics / configurable authenticators, every function here is a safe
 * no-op so the biometric button never renders and no native call is made.
 * Normal email/password + Google login are unaffected.
 */

export async function biometricAvailable() {
  return { available: false };
}

export async function biometricEnabled() {
  return false;
}

export async function enableBiometric() {
  return false;
}

export async function disableBiometric() {
  /* no-op */
}

export async function biometricLogin() {
  return { ok: false, reason: "disabled" };
}
